/*=========================================================================================
  File Name: moduleMessagerieGetters.js
  Description: Messagerie Module Getters
==========================================================================================*/

export default {
  activeConversation: state =>
    state.conversations.find(c => c.id === state.activeConversationId) || null,
};
